import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const inventoryDetailsBaseUrl = `${apiUrl}/inventoryDetails`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const inventoryDetailsApi = {
  getAll: (request) => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${inventoryDetailsBaseUrl}?${query}`);
  },
  count: id => {
    return Axios.get(`${inventoryDetailsBaseUrl}/count?${id}`, config);
  },
};
